<section class="header-section" *ngIf="pageData">
    <div>
        <h2 class="header">{{ pageData.header }}</h2>
        <p class="subheader">{{ pageData.subheader }}</p>
        <p class="description">{{ pageData.description }}</p>
        <button class="xm-btn-link-light show-modal" (click)="openPricingModal()">{{ pageData.showFullPricingCta }}</button>
    </div>
    <div class="display-card-container" *ngIf="isBusinessUser">
        <div class="upgrade-option-column">
            <div class="unl-card">
                <div class="card-header">
                    <div class="plan-name">{{ pageData.upgradePlanSeven.unlimitedPremium.planName }}</div>
                </div>
                <ul class="custom-bullet-list">
                    <li *ngFor="let features of pageData.upgradePlanSeven.unlimitedPremium.features">
                        <cms-text [originalText]="features"></cms-text>
                    </li>
                </ul>
                <p class="unl-price">{{pageData.upgradePlanSeven.unlimitedPremium.price}}</p>
                <p class="additional-line">{{pageData.upgradePlanSeven.unlimitedPremium.secondLineText}}</p>
            </div>
            <div class="broadband-label" *ngIf="!isBusinessUser">
                <xm-fcc-card>
                    <xm-fcc-broadband-label [labelDetails]="broadbandLabelData.unlimited.plans[1]">
                    </xm-fcc-broadband-label>
                </xm-fcc-card>
            </div>
            <xm-fcc-card page="plan-overview" *ngIf="isBusinessUser">
                <cbm-nutrition-label [isPlanSevenOverview]="true"
                    class="fcc-label column-{{labelResponse?.length}}"
                    [response]="labelResponse[1]">
                </cbm-nutrition-label>
            </xm-fcc-card>
        </div>
        <div class="upgrade-option-column">
            <div class="unl-card">
                <div class="card-header">
                    <div class="plan-name">{{ pageData.upgradePlanSeven.unlimited.planName }}</div>
                </div>
                <ul class="custom-bullet-list">
                    <li *ngFor="let features of pageData.upgradePlanSeven.unlimited.features">
                        <cms-text [originalText]="features"></cms-text>
                    </li>
                </ul>
                <p class="unl-price">{{ pageData.upgradePlanSeven.unlimited.price }}</p>
                <p class="additional-line">{{pageData.upgradePlanSeven.unlimited.secondLineText}}</p>
            </div>
            <div class="broadband-label" *ngIf="!isBusinessUser">
                <xm-fcc-card>
                    <xm-fcc-broadband-label [labelDetails]="broadbandLabelData.unlimited.plans[0]">
                    </xm-fcc-broadband-label>
                </xm-fcc-card>
            </div>
            <xm-fcc-card page="plan-overview" *ngIf="isBusinessUser">
                <cbm-nutrition-label [isPlanSevenOverview]="true"
                    class="fcc-label column-{{labelResponse?.length}}"
                    [response]="labelResponse[0]">
                </cbm-nutrition-label>
            </xm-fcc-card>
        </div>
    </div>
    <div class="display-card-container" *ngIf="!isBusinessUser">
        <div class="upgrade-option-column">
            <div class="unl-card">
                <div class="card-header">
                    <div class="plan-name">{{ pageData.upgradePlanEightResi.mobilePlus.planName }}</div>
                </div>
                <ul class="custom-bullet-list">
                    <li *ngFor="let features of pageData.upgradePlanEightResi.mobilePlus.features">
                        <cms-text [originalText]="features"></cms-text>
                    </li>
                </ul>
                <p class="unl-price">{{pageData.upgradePlanEightResi.mobilePlus.price}}</p>
                <p class="discount-text">{{ pageData.upgradePlanEightResi.mobilePlus.discountText }}</p>
                <p class="additional-line">{{pageData.upgradePlanEightResi.mobilePlus.secondLineText}}</p>
            </div>
            <div class="broadband-label" *ngIf="!isBusinessUser">
                <xm-fcc-card>
                    <xm-fcc-broadband-label [labelDetails]="broadbandLabelData.unlimited.plans[1]">
                    </xm-fcc-broadband-label>
                </xm-fcc-card>
            </div>
            <xm-fcc-card page="plan-overview" *ngIf="isBusinessUser">
                <cbm-nutrition-label [isPlanSevenOverview]="true"
                    class="fcc-label column-{{labelResponse?.length}}"
                    [response]="labelResponse[1]">
                </cbm-nutrition-label>
            </xm-fcc-card>
        </div>
        <div class="upgrade-option-column">
            <div class="unl-card">
                <div class="card-header">
                    <div class="plan-name">{{ pageData.upgradePlanEightResi.mobileSelect.planName }}</div>
                </div>
                <ul class="custom-bullet-list">
                    <li *ngFor="let features of pageData.upgradePlanEightResi.mobileSelect.features">
                        <cms-text [originalText]="features"></cms-text>
                    </li>
                </ul>
                <p class="unl-price">{{ pageData.upgradePlanEightResi.mobileSelect.price }}</p>
                <p class="discount-text">{{ pageData.upgradePlanEightResi.mobileSelect.discountText }}</p>
                <p class="additional-line">{{pageData.upgradePlanEightResi.mobileSelect.secondLineText}}</p>
            </div>
            <div class="broadband-label" *ngIf="!isBusinessUser">
                <xm-fcc-card>
                    <xm-fcc-broadband-label [labelDetails]="broadbandLabelData.unlimited.plans[0]">
                    </xm-fcc-broadband-label>
                </xm-fcc-card>
            </div>
            <xm-fcc-card page="plan-overview" *ngIf="isBusinessUser">
                <cbm-nutrition-label [isPlanSevenOverview]="true"
                    class="fcc-label column-{{labelResponse?.length}}"
                    [response]="labelResponse[0]">
                </cbm-nutrition-label>
            </xm-fcc-card>
        </div>
    </div>
    <div class="upgrade-desc" *ngIf="pageData.footerDescription">
        <cms-text>{{ pageData.footerDescription }}</cms-text>
    </div>
</section>
